<template>
  <div id="Book">
    <div class="font">
      <span>
        <b>眭海刚</b>，刘俊怡，徐川，马国锐，孙开敏，涂继辉，高分辨率遥感影像灾害目标损毁信息提取技术，武汉大学出版社，2022年。
      </span>
      <el-divider></el-divider>
      <span>
        马国锐，石岩，<b>眭海刚</b>，刘译璟，李文波，空天地大数据公共安全事件预测建模技术，科学出版社，2022年。
      </span>
      <el-divider></el-divider>
      
      <span>
        <b>眭海刚</b
        >，徐川，刘俊怡，基于特征的光学与SAR遥感图像配准，科技出版社，2017年。
      </span>
      <el-divider></el-divider>
      <span
        >孙向东，<b>眭海刚</b>，卫星遥感毁伤效果评估，国防工业出版社，2012年。</span
      >
      <el-divider></el-divider>
      <span
        >李德仁，朱庆，朱欣焰，<b>眭海刚</b>，面向任务的遥感信息聚焦服务，科学出版社，2010年。</span
      >
      <el-divider></el-divider>
      <span
        ><b>Sui,H.G.</b>, Zhou, Q.M., Gong, J.Y., Ma, G.R., Processing of
        multitemporal data and change detection. Advances in Photogrammetry,
        ISPRS.Congress BOOK. 2008, ISBN.978-0-4.</span
      >
      <el-divider></el-divider>
      <span
        >龚健雅，周启鸣，<b>眭海刚</b>，马国锐，多时相遥感影像变化检测，对地观测数据处理与分析研究进展，武汉大学出版社，2007年。</span
      >
      <el-divider></el-divider>
      <span
        >肖平，<b>眭海刚</b>，贾永红，遥感变化检测新技术，西安地图出版社，2005年。</span
      >
      <el-divider></el-divider>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang='less' scoped>
#Book {
  margin-top: 20px;
  .font {
    font-size: 14px;
    color: #454545;
    // font-family: "Times New Roman", Times, serif;
  }
}
</style>
